import { saveAs } from 'file-saver';
import type { Novel } from './store';

/**
 * Downloads the complete Novel state as a JSON blob.
 * Uses the custom .nexus extension.
 */
export function downloadBackup(novel: Novel): void {
    // Convert the in-memory novel directly to a formatted string
    const jsonString = JSON.stringify(novel, null, 2);

    // Create a Blob representing the data as a JSON file
    const blob = new Blob([jsonString], { type: 'application/json;charset=utf-8' });

    // Clean the title for the filename
    const cleanTitle = novel.title.replace(/\\s+/g, '_').replace(/[^a-zA-Z0-9_]/g, '');

    // Trigger browser download using file-saver
    saveAs(blob, `${cleanTitle}_Backup.nexus`);
}

/**
 * Parses a File object (from drag-and-drop or file input) back into a Novel object
 */
export async function handleFileImport(file: File): Promise<Novel> {
    const text = await file.text();
    const novel = JSON.parse(text) as Novel;

    // Validate basic shape
    if (!novel.id || !novel.title || !Array.isArray(novel.chapters)) {
        throw new Error('Invalid .nexus file format');
    }

    return novel;
}
